import { render, staticRenderFns } from "./service-info-section.vue?vue&type=template&id=46e9953a&scoped=true&"
import script from "./service-info-section.vue?vue&type=script&lang=js&"
export * from "./service-info-section.vue?vue&type=script&lang=js&"
import style0 from "./service-info-section.vue?vue&type=style&index=0&id=46e9953a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9953a",
  null
  
)

/* custom blocks */
import block0 from "@/lang/services.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Felements%2Fservice-info%2Fservice-info-section.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/messages.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Felements%2Fservice-info%2Fservice-info-section.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "./service-info-section.vue?vue&type=custom&index=2&blockType=i18n"
if (typeof block2 === 'function') block2(component)

export default component.exports